<template>
  <div>
    <el-container>
      <el-header
        style="
          height: 80px;
          padding: 20px;
          font-size: 16px;
          border-color: #ccc;
          border-bottom-style: solid;
          border-width: 1px;
        "
      >
        <span
          style="
            font-weight: bold;
            font: 700 30px/34px 'Microsoft YaHei';
            display: block;
            margin-bottom: 40px;
            color: #000;
            overflow: hidden;
            width: 600px;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: auto;
            margin-right: auto;
          "
          >{{ title==''?'暂无标题':title }}</span
        >
      </el-header>
    </el-container>
    <pre
      style="
        width: 600px;
        margin: 20px 0 0;
        margin-left: auto;
        margin-right: auto;
        font: 16px/30px 'Microsoft Yahei';
        word-break: normal;
        word-wrap: break-word;
      "
      >{{ content }}</pre
    >
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "mustknow",
  data() {
    return {
      id: this.$route.query.id,
      index: this.$route.query.index,
      content: "",
      title:""
    };
  },
  created() {
    this.getNotice();
  },
  components: {},
  computed: {},
  methods: {
    getNotice() {
      axios
        .get(
          `http://pt.zhzymedia.cn/api/client_login/Notices/v1?index=${this.index}&size=3&type=2`
          // `http://pt.zhzymedia.cn/api/client_login/Notices/v1?index=${this.index}&size=3&type=2`
        )
        .then((res) => {
          console.log(res.data.data);
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].id == this.id) {
              this.content = res.data.data[i].content;
              this.title= res.data.data[i].title;
              return;
            }
          }
        });
    },
  },
};
</script>

<style lang="less">
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
